export default __webpack_public_path__ + "static/media/up_arrow.15dba52b.png";